import { StoresListMetadata } from 'components/Basic/Head/StoresListMetadata/StoresListMetadata';
import CommonLayout from 'components/Layout/CommonLayout';
import Stores from 'components/Pages/Stores';
import { useStoreLocatorStores } from 'connectors/stores/StoreLocator';
import {
    MapProviderQueryDocumentApi,
    MapProviderQueryVariablesApi,
    StoreLocatorQueryDocumentApi,
    StoreLocatorQueryVariablesApi,
} from 'graphql/generated';
import { initServerSideProps, ServerSidePropsType } from 'helpers/InitServerSideProps';
import { getServerSidePropsWrapper } from 'helpers/serverSide/getServerSidePropsWrapper';
import { useGtmStaticPageView } from 'hooks/gtm/useGtmStaticPageView';
import useTranslation from 'next-translate/useTranslation';
import React, { useMemo } from 'react';
import { NextPageExtended } from 'types/global';
import { useGtmStaticPageViewEvent } from 'utils/Gtm/EventFactories';

const Index: NextPageExtended<ServerSidePropsType> = () => {
    const { t } = useTranslation();
    const { stores, serviceIcons, isLoading } = useStoreLocatorStores();
    const breadcrumbs = useMemo(() => [{ name: t('Department stores'), slug: '' }], [t]);
    const gtmStaticPageViewEvent = useGtmStaticPageViewEvent('stores', breadcrumbs);
    useGtmStaticPageView(gtmStaticPageViewEvent);

    return (
        <CommonLayout showLastVisitedProducts title={t('Stores')}>
            <StoresListMetadata stores={stores} />
            <Stores isLoading={isLoading} serviceIcons={serviceIcons} stores={stores} />
        </CommonLayout>
    );
};

Index.layout = 'plain';

export const getServerSideProps = getServerSidePropsWrapper(({ domainConfig, redisClient, t }) => async (context) => {
    return initServerSideProps<StoreLocatorQueryVariablesApi | MapProviderQueryVariablesApi>({
        context,
        domainConfig,
        redisClient,
        t,
        prefetchedQueries: [
            {
                query: StoreLocatorQueryDocumentApi,
            },
            {
                query: MapProviderQueryDocumentApi,
            },
        ],
    });
});

export default Index;
